export const internetStatuses = ["DRAFT", "PUBLISHED", "ARCHIVED"] as const;

export const internetAvailabilityStatuses = [
  "AVAILABLE",
  "PREORDER",
  "DISCONTINUED",
  "UNKNOWN",
] as const;

export const internetConnectionTypes = [
  "FTTH",
  "CABLE",
  "DSL",
  "FIXED_4G",
  "FIXED_5G",
  "SATELLITE",
] as const;

export const internetDataPolicies = [
  "UNLIMITED",
  "FAIR_USE",
  "CAPPED",
  "UNKNOWN",
] as const;

export const internetInstallationMethods = [
  "SELF",
  "TECHNICIAN",
  "EITHER",
  "CONDITIONAL",
  "UNKNOWN",
] as const;

export const internetAvailabilityScopes = [
  "NETWORK",
  "SELECTED_LOCATIONS",
  "ADDRESS_CHECK_REQUIRED",
  "UNKNOWN",
] as const;

export const internetNetworkAccessTypes = [
  "AON",
  "GPON",
  "XGS_PON",
  "DOCSIS",
] as const;

export type InternetSource = {
  id: string;
  url: string;
  factKeys: string[];
  checkedAt: string;
  effectiveAt?: string | null;
};

export type InternetCondition = {
  key: string;
  sourceIds: string[];
  locationIds?: string[];
  amountCents?: number | null;
  value?: string | number | boolean | null;
};

export type InternetEquipment = {
  routerModel?: string | null;
  ownership?: "LOAN" | "RENTAL" | "PURCHASE" | "OWN" | "UNKNOWN";
  wifiStandard?: string | null;
  includedMeshPoints?: number | null;
  sourceIds: string[];
};

export type InternetTechnicalFeatures = {
  ipv6?: boolean | null;
  publicIpv4?: boolean | null;
  staticIp?: boolean | null;
  cgnat?: boolean | null;
  ownRouterSupported?: boolean | null;
  bridgeModeSupported?: boolean | null;
  sourceIds: string[];
};

export type InternetAdditionalService = {
  key: string;
  type: "TV" | "PHONE" | "MESH" | "SECURITY" | "BUNDLE_DISCOUNT" | "OTHER";
  monthlyPriceCents?: number | null;
  upfrontPriceCents?: number | null;
  discountMonthlyCents?: number | null;
  included?: boolean | null;
  conditions?: InternetCondition[];
  sourceIds: string[];
};

export type InternetFactNotes = Record<string, string>;
